export type {
  IMultiselectProps,
  TMultiselectOptions as ISelectOptions
} from './multiselect';

export { default } from './multiselect';
